import React from "react";
import connect from "Shared/connect";
import * as styles from "./base.scss";
import Icon from "Shared/Icon";
import { pushState } from "Shared/history";
const Links = (prop) => (React.createElement("div", { className: styles.container }, !!prop.links &&
    prop.links.map((x) => (React.createElement("a", { key: x.url, className: styles.link, onClick: () => pushState(x.url), tabIndex: prop.tabIndex },
        React.createElement("span", { className: styles.text }, x.displayName),
        React.createElement(Icon, { name: "arrow-right-new", className: styles.icon }))))));
export default connect((state) => ({
    links: !!state.mainMenu && state.mainMenu.rightContentLinks,
}))(Links);
